import axios from 'axios';
import router from '@/router';

/**
 * 基础请求
 * @param obj 请求数据
 * @param i=0默认标记带token 1不需要带token
 */
//请求头
let request = axios.create(
    {
        baseURL: process.env.VUE_APP_BASE_API,
        timeout: 1000 * 30,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    }
);
/**
 * 请求拦截
 */
request.interceptors.request.use(config => {
    /*做一些其他事*/
    let token = JSON.parse(sessionStorage.getItem('token'));
    if (token) {
        // 请求头带上token
        config.headers['Authorization'] = token.token_type + ' ' + token.access_token;
    }
    return config;
}, error => {
    console.log('request error :' + error);
    return Promise.reject(error);
})
/**
 * 响应拦截
 */
request.interceptors.response.use(response => {
    if (response.data && response.data.code === 401) { // 401, token失效
        sessionStorage.removeItem('token');
        router.push({path: '/401'}, () => {
            location.reload(); // 刷新页面, 清空整站临时存储数据
        })
    }
    return response.data;
}, error => {
    // 放开会导致只要有401情况就跳转到登陆页面的情况，刷新token时可能会有问题
    if (error) {
        if (error.response) {
            let res = error.response;
            if (res.status === 401 || res.status === 404 || res.status === 500) {
                router.replace({
                    path: "/" + res.ststus
                })
            }
            return Promise.resolve(res.data);
        }
        return Promise.resolve(error);
    } else {
        router.push({path: '/401'}, () => {
            location.reload() // 刷新页面, 清空整站临时存储数据
        })
    }
    return Promise.reject(error);
})

export default request;
